/**
 * This file contains configuration for `gatsby-plugin-prismic-previews` to
 * support preview sessions from Prismic with unpublished documents.
 *
 * @see https://prismic.io/docs/technical-reference/gatsby-plugin-prismic-previews
 */

import { componentResolverFromMap } from "gatsby-plugin-prismic-previews"

import { GATSBY_PRISMIC_REPOSITORY_NAME } from "../env"
import { linkResolver } from "./linkResolver"
import PageTemplate from "../pages/{PrismicPage.url}"
import NewsPostTemplate from "../pages/{PrismicNewsPost.url}"
import StoryTemplate from "../pages/{PrismicStory.url}"
import StoriesTemplate from "../pages/stories"
import WhyIRidePage from "../pages/why-i-ride"

/**
 * Prismic preview configuration for each repository in your app. This set of
 * configuration objects will be used with the `withPrismicPreview` and
 * `withPrismicUnpublishedPreview` higher order components.
 *
 * If your app needs to support multiple Prismic repositories, add each of
 * their own configuration objects here as additional elements.
 *
 * @see https://prismic.io/docs/technical-reference/gatsby-plugin-prismic-previews#withprismicunpublishedpreview
 */
export const repositoryConfigs = [
	{
		repositoryName: GATSBY_PRISMIC_REPOSITORY_NAME,
		linkResolver,
		componentResolver: componentResolverFromMap({
			page: PageTemplate,
			news_post: NewsPostTemplate,
			story: StoryTemplate,
			stories: StoriesTemplate,
			why_i_ride: WhyIRidePage,
		}),
	},
]
